var _mask, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_223_101",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0002 0H0.000244141V34H15.0002V0ZM38.0002 0H23.0002V34H38.0002V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 0V-3H-2.99976V0H0.000244141ZM15.0002 0H18.0002V-3H15.0002V0ZM0.000244141 34H-2.99976V37H0.000244141V34ZM15.0002 34V37H18.0002V34H15.0002ZM23.0002 0V-3H20.0002V0H23.0002ZM38.0002 0H41.0002V-3H38.0002V0ZM23.0002 34H20.0002V37H23.0002V34ZM38.0002 34V37H41.0002V34H38.0002ZM0.000244141 3H15.0002V-3H0.000244141V3ZM3.00024 34V0H-2.99976V34H3.00024ZM15.0002 31H0.000244141V37H15.0002V31ZM12.0002 0V34H18.0002V0H12.0002ZM23.0002 3H38.0002V-3H23.0002V3ZM26.0002 34V0H20.0002V34H26.0002ZM38.0002 31H23.0002V37H38.0002V31ZM35.0002 0V34H41.0002V0H35.0002Z",
    fill: "#DFF8FF",
    mask: "url(#path-1-inside-1_223_101)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.9a980b979373345d924a0e1ddd04d44a.svg";
export { ForwardRef as ReactComponent };